import { TFunction } from 'i18next';

import { Conversation, Message as MessageModel, MessageType, User } from '../../../../data/models.ts';
import { isAdminUser } from '../../../../utils/loaders.ts';

export const getReceiver = (conversation?: Conversation, user?: User | null): User | undefined =>
    conversation?.participants.find(
        (participant) =>
            participant.id !== user?.id &&
            !isAdminUser(participant) &&
            (conversation.isParticipant || !participant.organizationId)
    );
export const formatSystemMessage = (t: TFunction<'site'>, message: MessageModel, viewerId?: string) => {
    const isUser = message.userId === viewerId;
    const isTargetUser = message.targetUserId === viewerId;

    const targetName = [message.targetUser?.firstName, message.targetUser?.lastName].filter(Boolean).join(' ');
    const userName = [message.user?.firstName, message.user?.lastName].filter(Boolean).join(' ');

    switch (message.messageType) {
        case MessageType.USER_ADDED:
            if (isUser) {
                return t('messagesPage.systemMessage.userAdded.asActor', { targetName });
            } else if (isTargetUser) {
                return t('messagesPage.systemMessage.userAdded.asTarget', { userName });
            } else {
                return t('messagesPage.systemMessage.userAdded.asOther', { userName, targetName });
            }

        case MessageType.USER_REMOVED:
            if (isUser) {
                return t('messagesPage.systemMessage.userRemoved.asActor', { targetName });
            } else if (isTargetUser) {
                return t('messagesPage.systemMessage.userRemoved.asTarget', { userName });
            } else {
                return t('messagesPage.systemMessage.userRemoved.asOther', { userName, targetName });
            }

        case MessageType.USER_JOINED:
            return t('messagesPage.systemMessage.userJoined.default', { targetName });

        case MessageType.USER_LEFT:
            return t('messagesPage.systemMessage.userLeft.default', { targetName });

        case MessageType.USER_REPORTED:
            if (isUser) {
                return t('messagesPage.systemMessage.userReported.asActor', { targetName });
            } else if (isTargetUser) {
                return t('messagesPage.systemMessage.userReported.asTarget', { userName });
            } else {
                return t('messagesPage.systemMessage.userReported.asOther', { userName, targetName });
            }

        case MessageType.USER_BLOCKED:
            if (isUser) {
                return t('messagesPage.systemMessage.userBlocked.asActor', { targetName });
            } else if (isTargetUser) {
                return t('messagesPage.systemMessage.userBlocked.asTarget', { userName });
            } else {
                return t('messagesPage.systemMessage.userBlocked.asOther', { userName, targetName });
            }
        case MessageType.USER_UNBLOCKED:
            if (isUser) {
                return t('messagesPage.systemMessage.userUnblocked.asActor', { targetName });
            } else if (isTargetUser) {
                return t('messagesPage.systemMessage.userUnblocked.asTarget', { userName });
            } else {
                return t('messagesPage.systemMessage.userUnblocked.asOther', { userName, targetName });
            }

        default:
            return message.text;
    }
};
